import { isPwl } from '@/utils/environment';

export const NO_FINAL_READ = 'NO_FINAL_READ';

export const MOVE_DATE_LABEL = 'Move date (dd/mm/yyyy)';

export const getMaxDaysInFutureForHomeMove = () => (isPwl() ? 14 : 28);

export const MOVE_IN_DATE_MESSAGE = `Enter the date your tenancy starts or your property sale is completed - this can be no more than ${getMaxDaysInFutureForHomeMove()} days in the future`;

export const MOVE_OUT_DATE_MESSAGE = `Enter the date your tenancy ends or your property sale is completed - this can be no more than ${getMaxDaysInFutureForHomeMove()} days in the future`;
